/**
 * HaulerCentral Auth Constants
 *
 * Storage keys and constants for HaulerCentral authentication.
 */

/**
 * Storage keys (app-prefixed to avoid collisions)
 */
export const AUTH_STORAGE_KEYS = {
  ACCESS_TOKEN: 'haulercentral_access_token',
  REFRESH_TOKEN: 'haulercentral_refresh_token',
  USER: 'haulercentral_user',
  AUTH_STATE: 'haulercentral-auth-storage', // For Zustand persist
} as const;

/**
 * Auth error messages
 */
export const AUTH_ERRORS = {
  INVALID_CREDENTIALS: 'Invalid email or password',
  USER_NOT_FOUND: 'User not found',
  EMAIL_ALREADY_EXISTS: 'An account with this email already exists',
  WEAK_PASSWORD: 'Password is too weak',
  INVALID_TOKEN: 'Invalid or expired token',
  SESSION_EXPIRED: 'Session expired. Please log in again',
  NETWORK_ERROR: 'Network error. Please check your connection',
  UNAUTHORIZED: 'Unauthorized. Please log in again',
  VERIFICATION_REQUIRED: 'Please verify your email address',
  TWO_FACTOR_REQUIRED: 'Two-factor authentication code required',
  INVALID_TWO_FACTOR_CODE: 'Invalid two-factor authentication code',
} as const;

/**
 * OAuth providers
 */
export const OAUTH_PROVIDERS = {
  GOOGLE: 'google',
  MICROSOFT: 'microsoft',
} as const;

/**
 * Token expiry times (in seconds)
 */
export const TOKEN_EXPIRY = {
  ACCESS_TOKEN: 604800, // 7 days
  REFRESH_TOKEN: 1209600, // 14 days
} as const;

/**
 * API endpoints
 */
export const AUTH_ENDPOINTS = {
  LOGIN: '/haulercentral/auth/login',
  REGISTER: '/haulercentral/auth/register',
  LOGOUT: '/haulercentral/auth/logout',
  ME: '/haulercentral/auth/me',
  REFRESH: '/haulercentral/auth/refresh',
  FORGOT_PASSWORD: '/haulercentral/auth/forgot-password',
  RESET_PASSWORD: '/haulercentral/auth/reset-password',
  VERIFY_EMAIL: '/haulercentral/auth/verify-email',
  RESEND_VERIFICATION: '/haulercentral/auth/resend-verification',
  UPDATE_PROFILE: '/haulercentral/auth/profile',
  TWO_FACTOR_STATUS: '/haulercentral/auth/2fa-status',
  ENABLE_2FA: '/haulercentral/auth/enable-2fa',
  CONFIRM_ENABLE_2FA: '/haulercentral/auth/confirm-enable-2fa',
  DISABLE_2FA: '/haulercentral/auth/disable-2fa',
  SEND_2FA_CODE: '/haulercentral/auth/send-2fa-code',
  VERIFY_2FA: '/haulercentral/auth/verify-2fa',
  OAUTH_BASE: '/haulercentral/auth/oauth',
  OAUTH_LINK: '/haulercentral/auth/oauth/link',
  OAUTH_UNLINK: '/haulercentral/auth/oauth/unlink',
} as const;

/**
 * Storage events for auth state changes
 */
export const AUTH_EVENTS = {
  LOGIN: 'haulercentral:login',
  LOGOUT: 'haulercentral:logout',
  TOKEN_REFRESH_START: 'auth:refresh-start',
  TOKEN_REFRESH_COMPLETE: 'auth:refresh-complete',
  TOKEN_REFRESH_ERROR: 'auth:refresh-error',
} as const;
